export default __webpack_public_path__ + "static/media/dron.e724705d.png";